module.exports = require('./meshCommon').TriangleMesh;